$('.top-site-alert__close-button').click(function () {
    const $container = $(this).closest('.top-site-alert');
    $container.addClass('d-none');

    BDC.Cookies.createCookie($container.data("alertId"), "true", 1);
});